/*
 * All visible copy for the storefront route, in two complete versions.
 * Chinese is fully Chinese (no bilingual lines); English is fully English.
 * Sophia to proofread the zh strings before launch.
 *
 * `nav` is also used by the shared Header, but only while the visitor is on the
 * storefront. Every other page gets `en`, so the English `nav` strings must stay
 * identical to the community app's originals.
 *
 * Credentials with an `id` that appears in CREDENTIAL_LINKS become links.
 */
export const COPY = {
  zh: {
    htmlLang: "zh-CN",

    nav: {
      home: "首页",
      myProfile: "我的主页",
      signIn: "登录",
      logOut: "退出登录",
      account: "账户",
      language: "语言",
    },
    communityFooter:
      "本站内容仅供学习交流。投资有风险，本金可能亏损。会员分享的投资组合仅用于讨论与学习，不构成任何投资建议或推荐。",

    profile: {
      sectionLabel: "关于财经索菲",
      name: "财经索菲",
      avatarAlt: "财经索菲",
      bio: "WInvest Collective 创始人兼首席执行官，致力于帮助 100\u00a0万女性迈出人生中的第一步投资。",
      credsLabel: "个人资历",
      creds: [
        { id: "investing", label: "7年+投资经验" },
        { id: "forbes", label: "福布斯欧洲「30 位 30 岁以下精英」金融榜" },
        { id: "innovateUk", label: "英国创新署Innovate UK 20万英镑奖金「Innovate UK Next Gen Fintech Award」" },
      ],
      socialsLabel: "在其他平台关注财经索菲",
      emailLabel: "发邮件至 sophia@winvestcollective.com",
    },

    productsLabel: "新书",
    book: {
      badge: "新书预告",
      subtitle: "海外年轻人的高性价比人生指南",
      blurb:
        "从第一份工资到第一笔投资，建立你的财富底气。适合第一次赚钱、开始存钱、想学习投资，却没人真正教过如何管理金钱的你。",
      author: "财经索菲 · 福布斯欧洲 30 位 30 岁以下精英（金融）",
      price: "£14.99",
    },

    waitlist: {
      formLabel: "加入新书等候名单",
      nameLabel: "姓名",
      namePlaceholder: "姓名",
      emailLabel: "邮箱",
      emailPlaceholder: "邮箱（请确认填写无误）*",
      emailError: "请输入有效的邮箱地址，例如 name@example.com。",
      submit: "加入新书等候名单",
      note: "新书上线时第一时间通知你。邮箱仅用于新书通知，可随时退订。",
      doneTitle: "你已加入等候名单！",
      doneText: "谢谢！新书上线时，我们会第一时间发邮件通知你。",
    },

    footer: {
      risk: "投资有风险，本金可能亏损。本页内容不构成任何投资建议。",
      powered: "由 WInvest Collective 提供支持",
    },
  },

  en: {
    htmlLang: "en",

    nav: {
      home: "Home",
      myProfile: "My profile",
      signIn: "Sign in",
      logOut: "Log out",
      account: "Account",
      language: "Language",
    },
    communityFooter:
      "For educational purposes only. Capital at risk. Members share their own portfolios for discussion and learning. Nothing here is financial advice or a recommendation.",

    profile: {
      sectionLabel: "About Sophia",
      name: "Sophia Lan",
      avatarAlt: "Sophia Lan",
      bio: "Founder & CEO @ WInvest Collective. Helping 1 million women make their first investment.",
      credsLabel: "Credentials",
      creds: [
        { id: "investing", label: "Investing since 2019" },
        { id: "forbes", label: "Forbes 30 Under 30 Finance Europe" },
        { id: "innovateUk", label: "Innovate UK Next Gen Fintech Award" },
      ],
      socialsLabel: "Sophia elsewhere",
      emailLabel: "Email sophia@winvestcollective.com",
    },

    productsLabel: "New book",
    book: {
      badge: "Coming soon",
      subtitle: "A wealth & investment guide for the next generation",
      blurb:
        "For the girl who got her first salary, saved her first $5,000, started investing — and realised no one ever really taught her how to handle money.",
      author: "Sophia Lan · Forbes 30 Under 30 Finance Europe",
      price: "£14.99",
    },

    waitlist: {
      formLabel: "Join the book waitlist",
      nameLabel: "Full name",
      namePlaceholder: "Full name",
      emailLabel: "Email",
      emailPlaceholder: "Email (please make sure you've entered it correctly)*",
      emailError: "Enter a valid email address, like name@example.com.",
      submit: "Join the waitlist",
      note: "Be the first to hear when the book launches. Book news only, unsubscribe anytime.",
      doneTitle: "You're on the waitlist!",
      doneText: "Thanks! You'll be among the first to hear when the book launches.",
    },

    footer: {
      risk: "Capital at risk. Nothing on this page is financial advice.",
      powered: "Powered by WInvest Collective",
    },
  },
};

// Where each credential links to (same in both languages).
export const CREDENTIAL_LINKS = {
  forbes: "https://www.forbes.com/profile/sophia-lan/",
  innovateUk: "https://gtr.ukri.org/projects?ref=10060718",
};

// The book's title is its brand name and stays the same in both languages.
export const BOOK_TITLE = "Now You Can.";
